module.exports = __webpack_public_path__ + "img/psdMachine.97a3f363.svg";